import Rx from 'rx';
import moment from 'moment';

export default function MemberDeliveriesCtrl($scope, WampCall, progressBar, $state, $anchorScroll, $mdMedia) {

  var uri = 'org.eggs.delivery_schedule';
  var vm = this;

  vm.mdMedia = $mdMedia;

  var s1 = $scope.$createObservableFunction('refresh')
      .startWith('nothing')
      .do(function () {
        vm.trades = {};
        vm.loadingEgg = true;
        vm.noItems = false;
        progressBar.add(uri);
      })
      .flatMap(function () {
        return new WampCall(uri);
      })
      .do(function (trades) {
        progressBar.remove(uri);
        vm.lastUpdated = moment();
        if (trades.length === 0) {
          vm.noItems = true;
        }
        else {
          vm.loadingEgg = false;
        }
      })
      .flatMap(function (trades) {
        return Rx.Observable.from(trades);
      })
      .groupBy(function (trade) {
        return trade.DeliveryDate;
      })
      .subscribe(
          function (groupedTrades) {
            groupedTrades
                .safeApply($scope, function (trade) {
                  vm.trades[groupedTrades.key] = vm.trades[groupedTrades.key] || [];
                  vm.trades[groupedTrades.key].push(trade);
                })
                .subscribe(function () {
                  if ($state.params.id) {
                    $anchorScroll('trade' + $state.params.id);
                  }
                });
          },
          function ($e) {
            vm.noItems = true;
            progressBar.remove(uri);
          });

  $scope.$on('$destroy', function () {
    s1.dispose();
    progressBar.remove(uri);
  });
}
